import { Input, Tabs, Form } from "antd";
import { useEffect, useState } from "react"; //useRef
import OrderDetails from "./OrderDetails";
import OrderListFilter from "./OrderListFilter";
import OrderListing from "./OrderListing/listing";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../redux/reducers/loader";
import { paginationLimit } from "../../../utils/helper/constants";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import toast from "react-hot-toast";
import * as Validation from "../../../utils/helper/validation";
import { useLocation, useNavigate } from "react-router-dom";
let timer = null;

const OrderListDetail = ({ defaultTabIndex, allCounts, getAllOrdersCount, permissionJson, inputData, setInputData, filter, setFilter, lockerDetails }) => {
  const { Search } = Input;
  const [OrderFilterOpen, setOrderFilterOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOrderDetail = (id) => {
    setOrderDetailId(id);
  };
  const showOrderFilter = () => {
    setOrderFilterOpen(true);
  };
  const handleOrderFilterClose = () => {
    setOrderFilterOpen(false);
  };

  //--------------------------------------------------------------------

  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [orderDetailId, setOrderDetailId] = useState(0);
  const [orderDetailData, setOrderDetailData] = useState({});
  const [qcRequestData, setQcRequestData] = useState({});
  const [qcData, setQcData] = useState({});
  // const [stopPagination, setStopPagination] = useState(false);
  // const containerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  console.log("orderDetailData", orderDetailData)
  /* Tabs State Change dynamiccly  */
  const [defaultIndex, setDefaultIndex] = useState("1");
  const onTabChange = (key) => {
    setDefaultIndex(key);
    setPaginationModel(paginationLimit);
  };

  const getAllOrders = async () => {
    dispatch(changeLoader(true));
    try {
      let timeslot = [];
      let orderDeliveryType = [];
      let branch = [];
      let sts = [];
      let zone = [];
      let vendor = [];
      let driver = [];
      let dropzone = [];
      let startdate = null;
      let enddate = null;
      if (filter.startdate) startdate = filter.startdate;
      if (filter.enddate) enddate = filter.enddate;
      if (filter.timeSlot) for (let item of filter.timeSlot) if (item?.isActive) timeslot.push(item?.code);
      if (filter.orderType) for (let item of filter.orderType) if (item?.isActive) orderDeliveryType.push(item?.code);
      if (filter.branch) for (let item of filter.branch) if (item?.isActive) branch.push(item?.code);
      if (filter.status) for (let item of filter.status) if (item?.isActive) sts.push(item?.code);
      if (filter.zone) for (let item of filter.zone) if (item?.isActive) zone.push(item?.code);
      if (filter.vendor) for (let item of filter.vendor) if (item?.isActive) vendor.push(item?.code);
      if (filter.driver) for (let item of filter.driver) if (item?.isActive) driver.push(item?.code);
      if (filter.dropzone) for (let item of filter.dropzone) if (item?.isActive) dropzone.push(item?.code);

      let status = "new-order";
      if (parseInt(defaultTabIndex) === 1) status = "new-order";
      if (parseInt(defaultTabIndex) === 2) status = "processing";
      if (parseInt(defaultTabIndex) === 3) status = "in-review";
      if (parseInt(defaultTabIndex) === 4) status = "ready-to-ship";
      if (parseInt(defaultTabIndex) === 5) status = "shipped";
      if (parseInt(defaultTabIndex) === 6) status = "ready-to-pickup";
      if (parseInt(defaultTabIndex) === 7) status = "noshow";
      if (parseInt(defaultTabIndex) === 8) status = "cancelled";
      if (parseInt(defaultTabIndex) === 9) status = "completed";

      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
        status: status,
        type: parseInt(defaultIndex) === 1 ? "pending" : "approved",
        time_slots: timeslot,
        branch: branch,
        sts: sts,
        zone_ids: zone,
        vendor_ids: vendor,
        driver_ids: driver,
        dropzone_ids: dropzone,
        orderDeliveryType: orderDeliveryType,
        startdate: startdate,
        enddate: enddate,
      };
      let response = await globalRequest(Apis.ORDERS.GET_ALL_ORDER_LIST, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        getAllOrdersCount({
          ...inputData,
          time_slots: timeslot,
          orderDeliveryType: orderDeliveryType,
          branch: branch,
          sts: sts,
          zone_ids: zone,
          vendor_ids: vendor,
          driver_ids: driver,
          dropzone_ids: dropzone,
          startdate: startdate,
          enddate: enddate,
        });
        if (apiResponse.data) {
          if (apiResponse?.data?.data?.length > 0) {
            if (paginationModel?.page > 1) {
              setList((prev) => [...prev, ...apiResponse?.data?.data]);
            } else {
              setList(apiResponse?.data?.data);
              setOrderDetailId(apiResponse?.data?.data[0].id);
            }
            // setStopPagination(false);
            // if(apiResponse?.data?.data?.length < paginationModel.limit)setStopPagination(true); // Stop pagination if no more data
          }
        } else {
          setList([]);
          setOrderDetailId(0);
          // setStopPagination(true);
        }
        setOrderFilterOpen(false);
        // setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getOrdersDetail = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {};
      let response = await globalRequest(Apis.ORDERS.GET_ORDER_DETAIL + "/" + orderDetailId, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setOrderDetailData(apiResponse?.data?.data);
        setQcRequestData(apiResponse?.data?.qc_request);
        setQcData(apiResponse?.data?.qc_data);
        // setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllOrders();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel, defaultIndex, filter]);

  useEffect(() => {
    if (orderDetailId > 0) {
      getOrdersDetail();
    }
    //getAllOrdersCount(countApiFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetailId]);

  const reloadPage = async () => {
    getOrdersDetail();
    getAllOrders();
  };

  useEffect(() => {
    // Get order_number from query params
    const params = new URLSearchParams(location.search);
    const rhOrderNumber = orderDetailData?.rhOrderNumber;
    const orderNumber = params.get("order_number");
    const search = rhOrderNumber || orderNumber
    if (search) {
      setInputData((prev) => ({
        ...prev,
        search: search,
      }));
      form.setFieldsValue({
        search: search,
      });
      params.delete("order_number");
      const newQueryString = params.toString();
      console.log(window.location.origin);
      const newUrl = `${window.location.pathname}${newQueryString ? `?${newQueryString}` : ""}`;
      navigate(newUrl, { replace: true });
    } else {
      form.setFieldsValue({
        search: inputData?.search || "",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);


  // useEffect(() => {
  //   form.setFieldsValue({
  //     search: inputData?.search || "",
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [inputData]);

  // const handleScroll = () => {
  //   if (stopPagination) return;

  //   const container = containerRef.current;
  //   if (container) {
  //     const { scrollTop, scrollHeight, clientHeight } = container;
  //     if (scrollTop + clientHeight >= scrollHeight - 10) {
  //       console.log(scrollTop ,clientHeight , scrollHeight ,paginationModel);
  //       setPaginationModel((prev) => ({
  //         ...prev,
  //         page: prev.page + 1,
  //       }));
  //     }
  //   }
  // };

  // useEffect(() => {
  //   const container = containerRef.current;
  //   if (container) {
  //     container.addEventListener("scroll", handleScroll);
  //   }
  //   return () => {
  //     if (container) {
  //       container.removeEventListener("scroll", handleScroll);
  //     }
  //   };
  // }, [stopPagination]);

  //-----------------------------------------------------------
  // const fetchMoreOrders = async () => {
  //   if(!stopPagination){

  //   }
  //   console.log('fetchMoreOrders',paginationModel);
  //   // setPaginationModel({ page: paginationModel.page+1, limit:paginationModel.limit  })
  // }

  // const [loading, setLoading] = useState(false);
  // const loaderRef = useRef(null);

  // // Intersection Observer for infinite scroll
  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       const entry = entries[0];
  //       if (entry.isIntersecting && !loading) {
  //         setLoading(true);
  //         fetchMoreOrders().finally(() => setLoading(false));
  //       }
  //     },
  //     { root: null, rootMargin: "0px", threshold: 1.0 }
  //   );

  //   if (loaderRef.current) {
  //     observer.observe(loaderRef.current);
  //   }

  //   return () => {
  //     if (loaderRef.current) observer.unobserve(loaderRef.current);
  //   };
  // }, [loading, fetchMoreOrders]);

  const [scrollHightIndex, setScrollHightIndex] = useState(0);

  const handleParentScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      scrollTop + clientHeight - scrollHightIndex > 20 &&
      scrollHightIndex < scrollTop + clientHeight &&
      scrollTop + clientHeight >= scrollHeight - 10
    ) {
      // console.log('ankit ',paginationModel.page,scrollHightIndex,scrollTop + clientHeight, scrollHeight - 10);
      setScrollHightIndex(scrollTop + clientHeight);
      setPaginationModel((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  return (
    <div className="flex">
      <div className="w-full max-w-[320px] min-w-[320px] border-gray-250 border-b border-l border-r overflow-y-auto">
        {/* ref={containerRef} */}
        <div className="p-[18px] border-gray-250 border-b">
          <div className="flex items-center">
            <Form form={form} autoComplete="off" layout="inline">
              <Form.Item name="search">
                <Search
                  placeholder="Search by Order ID"
                  allowClear={true}
                  className="mr-[12px] cursor-pointer"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    if (value.length >= 5) {
                      setInputData((prev) => ({ ...prev, search: value }));
                      setPaginationModel((prev) => ({ ...prev, page: 1 }));
                      form.setFieldsValue({
                        ...filter,
                        search: value?.trimStart(),
                      });
                    } else if (value.length === 0) {
                      setInputData((prev) => ({ ...prev, search: "" }));
                      setPaginationModel((prev) => ({ ...prev, page: 1 }));
                      // form.setFieldsValue({
                      //   ...filter,
                      //   search: "",
                      // });
                    }
                  }}
                />
              </Form.Item>
            </Form>
            <img src="/images/Filter.png" alt="Filter" className="w-[24px] h-[24px] cursor-pointer" onClick={showOrderFilter} />
          </div>
        </div>
        <div className="custom-tabs custom-TabCenter !w-full two-custom-tabs">
          {parseInt(defaultTabIndex) === 1 ? (
            <Tabs activeKey={defaultIndex} onChange={onTabChange} className="w-full">
              <Tabs.TabPane tab={<>Pending {<span>{allCounts.pending_count}</span>}</>} key={1} className="w-[7rem]">
                <div className="overflow-y-auto overflow-x-hidden h-[881px]" onScroll={handleParentScroll}>
                  <OrderListing handleOrderDetail={handleOrderDetail} list={list} />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab={<>Approved {<span>{allCounts.approve_count}</span>}</>} key={2} className="w-[7rem]">
                <div className="overflow-y-auto overflow-x-hidden h-[881px]" onScroll={handleParentScroll}>
                  <OrderListing handleOrderDetail={handleOrderDetail} list={list} />
                </div>
              </Tabs.TabPane>
            </Tabs>
          ) : (
            <div className="overflow-y-auto overflow-x-hidden h-[881px]" onScroll={handleParentScroll}>
              <OrderListing handleOrderDetail={handleOrderDetail} list={list} />
            </div>
          )}
        </div>
        {/* <div className="h-10 flex items-center justify-center">
          {!stopPagination && (
            <Button
              type="primary"
              size={14}
              className="mx-1.5 cursor-pointer"
              onClick={() => {
                setPaginationModel((prev) => ({
                  ...prev,
                  page: prev.page + 1,
                }));
              }}
            >
              Load More
            </Button>
          )}
        </div> */}
        {/* Loader element for detecting scroll */}
        {/* <div ref={loaderRef} className="h-10 flex items-center justify-center">
          {loading && <span>Loading...</span>}
        </div> */}
      </div>

      {orderDetailData && (
        <OrderDetails
          orderDetailId={orderDetailId}
          orderDetailData={orderDetailData}
          reloadPage={reloadPage}
          qcRequestData={qcRequestData}
          qcData={qcData}
          permissionJson={permissionJson}
          lockerDetails={lockerDetails}
        />
      )}

      {OrderFilterOpen && (
        <OrderListFilter isOpen={OrderFilterOpen} onClose={handleOrderFilterClose} filter={filter} setFilter={setFilter} />
      )}
    </div>
  );
};
export default OrderListDetail;
